import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-spcod/sportprice/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}
export const getPage = (current, size, params) => {
  return request({
    url: '/api/park-spcod/sportprice/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/park-spcod/sportprice/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/park-spcod/sportprice/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/park-spcod/sportprice/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/park-spcod/sportprice/submit',
    method: 'post',
    data: row
  })
}



export const removeOne = (id) => {
  return request({
    url: '/api/park-spcod/sportprice/remove/' + id,
    method: 'post'
  })
}
// export const getSportGroundInfo = (id) => {
//   return request({
//     url: '/api/park-spcod/sportground/getSportGroundInfo',
//     method: 'get',
//     params: {
//       id,
//     }
//   })
// }
